// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {connect} from 'react-redux'
import Table from '../../Table'
import {renderFormField, renderFormSelectField} from '../../../utils/formFields'
import {addUser, updateUser, deleteUser, fetchUsers} from '../../../actions/userManagement'
import Modal from '../../Modal'
import ToggleContent from '../../Toggle'
import ConfirmationMessage from '../../ConfirmationMessage'
import config, {FEATURE_USER_MANAGEMENT_PROFILES_EDIT} from '../../../config'
import moment from 'moment'

// Icons
import {AdminIconComponent, UserIconComponent} from '../../../media/icons/UserIconsComponent'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import './index.css'

const roles = [
  {
    value: 'TenantUser',
    name: 'User'
  },
  {
    value: 'TenantAdmin',
    name: 'Admin'
  }
]

const userIcons = {
  'TenantAdmin': <AdminIconComponent/>,
  'TenantUser': <UserIconComponent/>
}

const accountStatus = {
  UNCONFIRMED: 'Unconfirmed',
  CONFIRMED: 'Confirmed',
  ARCHIVED: 'Inactive',
  COMPROMISED: 'Compromised',
  UNKNOWN: 'Unknown',
  RESET_REQUIRED: 'Password Reset Required',
  FORCE_CHANGE_PASSWORD: 'Password Change Required'
}

class ProfilesTable extends Component {

  componentDidMount () {
    this.props.fetchUsers()
  }

  renderUserIcon (role) {
    return userIcons[role]
  }

  tableHeaders () {
    return (
      <>
        <div className='th col-1'>User</div>
        <div className='th col'>First name</div>
        <div className='th col'>Last name</div>
        <div className='th col-3'>Username (email address)</div>
        <div className='th col'>Permissions</div>
        <div className='th col'>Creation Date</div>
        <div className='th col'>Last Edited Date</div>
        <div className='th col'>Account Status</div>
        <div className='th col-1'>User Status</div>
        <div className='th col-1'></div>
      </>
    )
  }

  addFormFields () {
    const emailDomain = this.props.session.user_data.email.split('@')[1]
    const date = this.formatDate(new Date())

    return (
      <>
        <div className='th col-1 user-icon'><UserIconComponent/></div>
        <div className='td col'>
          {renderFormField('firstName', 'text', 'First name')}
        </div>
        <div className='td col'>
          {renderFormField('lastName', 'text', 'Last name')}
        </div>
        <div className='td col-3 row add-email-row'>
          <div className='td col email-col'>
            {renderFormField('userName', 'text', 'Username')}
          </div>
          <div className='td col email-col'>
            <span>@{emailDomain}</span>
          </div>
        </div>
        <div className='td col'>
          {renderFormSelectField('role', roles, 'value', 'name', 'col-12')}
        </div>
        <div className='td col td-text-field'>
          <span>{date}</span>
        </div>
        <div className='td col td-text-field'>
          <span>{date}</span>
        </div>
        <div className='td col td-text-field'>
          <span>Password Change Required</span>
        </div>
        <div className='td col td-text-field'>
          <span>Enabled</span>
        </div>
      </>
    )
  }

  updateFormFields = (item) => {
    const props = {}

    if (!config[FEATURE_USER_MANAGEMENT_PROFILES_EDIT]) {
      props['disabled'] = true
    }

    const {created, modified, enabled} = item
    const createdDate = this.formatDate(this.convertTimestamp(created))
    const modifiedDate = this.formatDate(this.convertTimestamp(modified))
    const userStatus = enabled ? 'Enabled' : 'Disabled'

    return (
      <>
        <div className='th col-1 user-icon'>{this.renderUserIcon(item.role)}</div>
        <div className='td col'>
          {renderFormField('firstName', 'text', 'First name', false, item.firstName, props)}
        </div>
        <div className='td col'>
          {renderFormField('lastName', 'text', 'Last name', false, item.lastName, props)}
        </div>
        <div className='td col-3 update-email-row'>
          <span>{item.userName}</span>
          {renderFormField('userName', 'hidden', 'Username', 'hidden', item.userName, props)}
        </div>
        <div className='td col'>
          {renderFormSelectField('role', roles, 'value', 'name', 'col-12', props)}
        </div>
        <div className='td col td-text-field'>
          <span>{createdDate}</span>
        </div>
        <div className='td col td-text-field'>
          <span>{modifiedDate}</span>
        </div>
        <div className='td col td-text-field'>
          <span>{accountStatus[item.status]}</span>
        </div>
        <div className='td col td-text-field'>
          <span>{userStatus}</span>
        </div>
      </>
    )
  }

  updateButtons = (item) => {
    return (
      <>
        <div className='button remove'>
          <ToggleContent
            toggle={show => <button className='edit-button' onClick={(e) => {show(); e.preventDefault()}}><DeleteOutlineIcon/>&nbsp; Remove</button>}
            content={hide => (
              <Modal onHide={hide}>
                <ConfirmationMessage onAccept={() => {this.props.deleteUser(item.userName, item.firstName, item.lastName); hide()}} onCancel={hide}>
                  <span>Are you sure you want to remove <b>{item.firstName} {item.lastName}</b> from your account?</span>
                </ConfirmationMessage>
              </Modal>
            )}
          />
        </div>
      </>
    )
  }

  infoFields = (item) => {
    const {created, modified, enabled} = item
    const createdDate = this.formatDate(this.convertTimestamp(created))
    const modifiedDate = this.formatDate(this.convertTimestamp(modified))
    const userStatus = enabled ? 'Enabled' : 'Disabled'
    return (
      <>
        <div className='th col-1 user-icon'>{this.renderUserIcon(item.role)}</div>
        <div className='td col'>
          <span>{item.firstName}</span>
        </div>
        <div className='td col'>
          <span>{item.lastName}</span>
        </div>
        <div className='td col-3'>
          <span>{item.userName}</span>
        </div>
        <div className='td col'>
          <span>{item.role === 'TenantUser' ? 'User' : 'Admin'}</span>
        </div>
        <div className='td col'>
          <span>{createdDate}</span>
        </div>
        <div className='td col'>
          <span>{modifiedDate}</span>
        </div>
        <div className='td col'>
          <span>{accountStatus[item.status]}</span>
        </div>
        <div className='td col'>
          <span>{userStatus}</span>
        </div>
      </>
    )
  }

  convertTimestamp (timestamp) {
    return new Date(timestamp * 1000)
  }

  formatDate (date) {
    const momentDate = moment(date)
    return momentDate.format('MMM Do, YYYY [at] h:mm a')
  }

  validateAdd (values) {
    let ret = {}
    if (!values.userName || !values.userName.trim()) {
      ret = {...ret, userName: 'Email cannot be blank'}
    }
    if (!values.firstName || !values.firstName.trim()) {
      ret = {...ret, firstName: 'First name cannot be blank'}
    }
    if (!values.lastName || !values.lastName.trim()) {
      ret = {...ret, lastName: 'Last name cannot be blank'}
    }
    if (!values.role || !values.role.value) {
      ret = {...ret, role: 'Permissions cannot be blank'}
    }
    if (!values.enabled) {
      ret = {...ret, enabled: 'User status cannot be blank'}
    }
    return ret
  }

  validateUpdate (values) {
    let ret = {}
    if (!values.firstName || !values.firstName.trim()) {
      ret = {...ret, firstName: 'First name cannot be blank'}
    }
    if (!values.lastName || !values.lastName.trim()) {
      ret = {...ret, lastName: 'Last name cannot be blank'}
    }
    return ret
  }

  render () {
    return (
      <div className='profiles'>
        <Table
          tableHeaders={this.tableHeaders()}
          items={this.props.userManagement.users}
          addFields={this.addFormFields()}
          validateAdd={this.validateAdd}
          onAddSubmit={this.props.addUser}
          addItemText={'Add a new user'}
          validateUpdate={this.validateUpdate}
          onUpdateSubmit={this.props.updateUser}
          updateFields={this.updateFormFields}
          infoFields={this.infoFields}
          updateButtons={this.updateButtons}
          editEnabled={true}
        />
      </div>
    )
  }
}

function mapStateToProps ({session, userManagement}) {
  return {session, userManagement}
}

export default connect(mapStateToProps, {addUser, updateUser, deleteUser, fetchUsers})(ProfilesTable)
